<div class="discussions-messages">

  <div class="discussion-message-group" *ngFor="let messageGroup of discussionMessages">

    <div class="discussion-message" *ngIf="messageGroup.type === types.OPERATOR">
      <div [ngClass]="getMessageTypeClass(operatorType, messageGroup.type)" *ngFor="let message of messageGroup.messages">
        <div [ngClass]="getMessageTextTypeClass(operatorType, messageGroup.type)"
             [innerHTML]="message.DiscussionMessage"
             attr.data-automation-id="bc-discussion-message-agent-{{ getMessageTextTypeClass(operatorType, messageGroup.type) }}"></div>
      </div>
    </div>

    <div class="discussion-message" *ngIf="messageGroup.type === types.HELPER">
      <div [ngClass]="getMessageTypeClass(operatorType, messageGroup.type)" *ngFor="let message of messageGroup.messages">
        <div [ngClass]="getMessageTextTypeClass(operatorType, messageGroup.type)"
             [innerHTML]="message.DiscussionMessage"
             attr.data-automation-id="bc-discussion-message-helper-{{ getMessageTextTypeClass(operatorType, messageGroup.type) }}"></div>
      </div>
    </div>

    <div class="discussion-message" *ngIf="messageGroup.type === types.SYSTEM">
      <div class="system-message"
           *ngFor="let message of messageGroup.messages"
           [attr.data-automation-id]="'bc-discussion-message-system'">
        <div [innerText]="formatSystemMessage(message)"></div>
      </div>
    </div>

    <div *ngIf="messageGroup.type !== types.SYSTEM" [ngClass]="getTimestampClass(operatorType, messageGroup.type)" class="discussion-message-timestamp">
      <span>{{ formatTimestamp(messageGroup) }}</span>
    </div>

  </div>
</div>

